<template lang="pug">
	div
		Alerts(ref="Alerts")

		b-form(@submit.prevent='submit')

			h4.mb-3 Авторизация
			// p.text-muted Вход для членов, так сказать...

			component(:is="field.widget" v-model="form[field.name]" v-for="field in loginFormModel" :key="field.name" :_field="field" :_checkState="checkState" :_invalidFeedback="invalidFeedback")

			.g-between-center
				b-button.px-4(variant='primary' type='submit' :disabled="auth.isFetching")
					b-spinner.mr-2(label="Loading..." small v-if="auth.isFetching")
					| Войти

				b-button.px-0(variant='link' to="/reset-password-email") Забыли пароль?

</template>
<script>
	import {mapState} from 'vuex'

	import Alerts from '../../components/Alerts'

	import loginFormModel from './loginFormModel';
	import loginModel from './loginModel';

	import parseUrlMixin from '@/MIXINS/parseUrl';
	import clearFormMixin from '@/MIXINS/clearForm';
	import formBackValidationMixin from '@/MIXINS/formBackValidation';
	import collectFormData from '@/MIXINS/collectFormData';


	export default {
		name: 'MyCadfemLogin',
		components: {
			Alerts,
		},
		mixins: [
			parseUrlMixin,
			clearFormMixin,
			formBackValidationMixin,
			collectFormData,
		],
		data: () => ({
			loginFormModel,
			form: { ...loginModel },
			msg: {
				ok: "Аутентификация прошла успешно",
				err: null,
				netErr: 'Произошла ошибка! Проверьте интернет соединение или попробуйте повторить попытку позднее!'
			},
			enterDelay: 500,
		}),
		computed: {
			...mapState(['auth']),
			error(){ return this.auth.error },
		},
		methods: {
			okHandlerAfter(){
				const urlData = this.parseUrl(window.location.search);
				const url = urlData.redirect_url ? decodeURIComponent(urlData.redirect_url): '/';
				setTimeout( () => (window.location.href = url), this.enterDelay )
			},
			okHandlerBefore(){
				this.clearForm('form');
			},
			async successFormHandler(resp){
				await this.$refs.Alerts.showAlert(this.msg.ok, 'success');
				await this.clearForm('form');
				await this.okHandlerAfter(resp);
			},
			errorFormHandler(error){
				error.non_field_errors
					? this.$refs.Alerts.showAlert(error.non_field_errors[0], 'error')
					: this.$refs.Alerts.showAlert(this.msg.err, 'error')
			},
			submit() {
				this.$store.dispatch('logIn', this.collectFormData(this.form))
					.then( resp=>{
						if (!resp.ok) throw resp.body;
						this.successFormHandler(resp)
					} )
					.catch( this.errorFormHandler );
			},
		},
	}
</script>
